import PropTypes from 'prop-types';

export default PropTypes.shape({
  shortTitle: PropTypes.string,
  title: PropTypes.string,
  category: PropTypes.string,
  set: PropTypes.func.isRequired,
  subscribe: PropTypes.func.isRequired,
});
